export enum WarehousePricingVersion {
    static2022 = "static2022",
    dynamic2023 = "dynamic2023",
    none = "none"
}
